import React from "react";
import { IoMdRemove, IoMdAdd } from "react-icons/io";
const QuantitySelector = ({
  value = 1,
  onChange,
  min = 1,
  max = 99,
  color,
}) => {
  const increase = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  const decrease = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  return (
    <div className={`flex items-center text-${color} border rounded-md w-fit`}>
      <button
        onClick={decrease}
        className={`px-3 py-1 text-${color} text-[1.4rem] font-bold`}
      >
      <IoMdRemove/>
      </button>

      <span className={`px-4 py-1 text-${color} min-w-[40px] text-center`}>
        {value}
      </span>

      <button
        onClick={increase}
        className={`px-3 py-1 text-${color} text-[1.4rem] text-lg font-bold`}
      >
        <IoMdAdd/>
      </button>
    </div>
  );
};

export default QuantitySelector;